export default (to, from, savedPosition) => {
      // 같은 부모 route 내 자식 간 이동이면 스크롤 위치 유지 (탭 간 전환)
      // 예: /ds/curation/total → /ds/curation/interest
      const getParentPath = (path) => path?.split('/').slice(0, -1).join('/');
      const fromParent = getParentPath(from?.path);
      const toParent = getParentPath(to?.path);

      if (fromParent && fromParent === toParent && fromParent.includes('/curation')) {
        return false;
      }

      // 스크롤 제어를 backScrollPosMixin과 afterEach에 위임
      // savedPosition을 반환하면 이전 페이지의 스크롤 위치가 적용되어 깜빡임 발생
      return false;
    }
